import { fromThisDateToThisDate } from "./daysFunction";
import { fromThisWeekToThisWeek } from "./weekFunction";
import { fromThisMonthToThisMonth } from "./monthsFunction";
import { fromThisQuarterToThisQuarter } from "./quarterFunction";
import { fromThisYearToThisYear } from "./yearsFunction";

const getDateRange = (relativeDateIs, dateUnit) => {
  const dateFunctions = {
    "Days": fromThisDateToThisDate,
    "Weeks": fromThisWeekToThisWeek,
    "Months": fromThisMonthToThisMonth,
    "Quarters": fromThisQuarterToThisQuarter,
    "Years": fromThisYearToThisYear,
  };

  // Check if the dateUnit exists in the dateFunctions object
  if (dateFunctions[dateUnit]) {
    const { formattedStartDate, formattedEndDate } = dateFunctions[dateUnit](relativeDateIs);
    return { minValue: formattedStartDate, maxValue: formattedEndDate };
  }

  return { minValue: null, maxValue: null }; // Return null if the dateUnit is not found
};

const thisToThisDateFunction = (relativeDateIs, dateUnit) => {
  // console.log(dateUnit);
  // console.log(relativeDateIs);

  return getDateRange(relativeDateIs, dateUnit);
};

export { thisToThisDateFunction };
